export const GLOBAL_STATE = 'FileExchanger'

export const E_LIBRARY = 'E_LIBRARY' as const
export const E_LIBRARY_LIST = 'E_LIBRARY_LIST' as const
export const E_LIBRARY_ALL = 'E_LIBRARY_ALL' as const
export const E_LIBRARY_CREATE = 'E_LIBRARY_CREATE' as const
export const E_LIBRARY_DELETE = 'E_LIBRARY_DELETE' as const
export const E_LIBRARY_TYPES = 'E_LIBRARY_TYPES' as const
